import { useState, useEffect, useRef } from "react";
import { CorpHeader } from '../../common/corp-header'
import { CorpFooter } from '../../common/corp-footer'
import './404.css'

export const Error404 = (props: {}) => {
  const ftr = useRef<HTMLElement>(null)

  // ユーザエージェントでヘッダとフッタを出し分ける
	var useragent = window.navigator.userAgent;
	if (useragent.startsWith('jp.family_network.ios_') || useragent.startsWith('jp.family_network.android_')) {
    return <>
      <article><main className="wrapper">
        <section className="error__section">
          <h2>ページが見つかりません。</h2>
        </section>
      </main></article>
    </>
  }else{
    return <>
    <article><main className="wrapper">
      <CorpHeader />
      <section className="error__section">
        <h2>ページが見つかりません。</h2>
      </section>
      <CorpFooter ref={ftr} />
    </main></article>
  </>  
  }
};
